import { SearchCriteria } from "./search-criteria";

export class GetClientGroupsSearchCriteria extends SearchCriteria {

}
